import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BazowyComponent } from 'src/app/komponenty/bazowy.component';
import { DodajZespolModel } from 'src/app/modele/projekty/zespoly/dodajZespolModel';
import { WykonawcaZespolu } from 'src/app/modele/projekty/zespoly/wykonawcaZespolu';
import { AuthService } from 'src/app/serwisy/ogolne/auth.service';
import { LoaderService } from 'src/app/serwisy/ogolne/loader.service';
import { SlownikiService } from 'src/app/serwisy/projekty/slowniki.service';
import { ZespolyService } from 'src/app/serwisy/projekty/zespoly.service';

@Component({
  selector: 'app-dodaj-zespol-modal',
  templateUrl: './dodaj-zespol-modal.component.html',
  styleUrls: ['./dodaj-zespol-modal.component.css']
})
export class DodajZespolModalComponent extends BazowyComponent implements OnInit {

  idProjektu: string;
  model: DodajZespolModel = new DodajZespolModel();
  wykonawcy: Array<WykonawcaZespolu>;
  wykonawcyDoListy: Array<WykonawcaZespolu>;
  czyZaladowanoDane: boolean;
  idWykonawcy: string;
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;

  constructor(
    public router: Router,
    modalService: NgbModal,
    public activeModal: NgbActiveModal,
    loaderSerwis: LoaderService,
    komunikatSerwis: ToastrService,
    public authService: AuthService,
    public zespolySerwis: ZespolyService,
    public translateSerwis: TranslateService,
    private activatedRoute: ActivatedRoute) {
    super(authService, modalService, loaderSerwis, komunikatSerwis, router, translateSerwis);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.pobierzDaneDoEkranu();
    });
  }

  pobierzDaneDoEkranu() {
    this.zespolySerwis.pobierzWykonawcowDoEdycjiZespolu().subscribe(
      (rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.wykonawcy = rezultat.listaElementow;
          this.wykonawcyDoListy = rezultat.listaElementow;
          this.czyZaladowanoDane = true;

          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      }
    );
  }


  zapisz() {
    this.model.idProjektu = this.idProjektu;
    this.model.idWykonawcow = new Array();
    this.wykonawcy.filter(m => m.czyWybrany).forEach(m => {
      this.model.idWykonawcow.push(m.id);
    })

    this.zespolySerwis.dodajZespol(this.model).subscribe(
      (rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.wyswietlKomunikat("Zespół został dodany");
          this.activeModal.close(true);
          return;
        }
        if (this.bladModelu(rezultat)) {
          this.bledyWalidacji = rezultat.bledyModelu;
          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      }
    );
  }

  wybierzWykonawce() {
    //this.model.idWykonawcow.push(this.idWykonawcy);

    var wykonawca = this.wykonawcy.find(m => m.id == this.idWykonawcy);
    wykonawca.czyWybrany = true;
    this.ngSelectComponent.clearModel();
    this.ngSelectComponent.handleClearClick();
    this.ngSelectComponent.blur();
    this.idWykonawcy = null;

    this.wykonawcyDoListy = [...this.wykonawcy.filter(m => !m.czyWybrany)];
  }

  pobierzWybranychWykonawcow() {
    return this.wykonawcy.filter(m => m.czyWybrany)
  }

  customSearchFn(term: string, item: WykonawcaZespolu) {
    term = term.toLocaleLowerCase();
    return item.imie.toLocaleLowerCase().indexOf(term) > -1 ||
      item.nazwisko.toLocaleLowerCase().indexOf(term) > -1 ||
      item.telefon.toLocaleLowerCase().indexOf(term) > -1 ||
      (item.imie + " " + item.nazwisko).toLocaleLowerCase().indexOf(term) > -1 ||
      (item.nazwisko + " " + item.imie).toLocaleLowerCase().indexOf(term) > -1
      ;
  }

  usunWybranegoWykonawce(id: string) {
    var wykonawca = this.wykonawcy.find(m => m.id == id);
    wykonawca.czyWybrany = false;

    this.wykonawcyDoListy = [...this.wykonawcy.filter(m => !m.czyWybrany)];
  }

}
